var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "btn-contact-switch", on: { click: _vm.open } },
    [
      _c("span", { staticClass: "keyboard-shortcut" }, [_vm._v(" TAB ")]),
      _vm._v(" "),
      _c("span", { staticClass: "material-icons" }, [_vm._v(" grid_view ")]),
      _vm._v(" "),
      _c("div", { staticClass: "add-button-text" }, [
        _vm._v(_vm._s(_vm.$t("chatWindow.live"))),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }